var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCall = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Call",
    d: "M7.08861 0.918466L2.52338 1.42571C1.94593 1.48987 1.4991 1.94455 1.52908 2.52478C1.63523 4.57917 2.49763 9.56848 7.89964 14.9705C13.3016 20.3725 18.2917 21.2357 20.3465 21.3422C20.9268 21.3723 21.3816 20.9254 21.4458 20.3479L21.953 15.7829C22.0077 15.2906 21.7647 14.8128 21.3346 14.5671L17.9158 12.614C17.4294 12.3362 16.8173 12.4182 16.4212 12.8143L15.0879 14.1475C14.7943 14.4412 14.373 14.5661 13.9879 14.4107C13.2892 14.1287 12.0808 13.4948 10.7288 12.1427C9.37672 10.7907 8.74279 9.58229 8.46082 8.88365C8.30537 8.4985 8.43029 8.07726 8.72398 7.78357L10.0572 6.4503C10.4533 6.05423 10.5353 5.44209 10.2575 4.95573L8.30441 1.5369C8.0587 1.10679 7.58094 0.863763 7.08861 0.918466Z",
    stroke: "currentColor",
    strokeWidth: 1.24222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Call.3ef6c58e6caa91f6094c8eab01415d3a.svg";